export const YouTubeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.2125 10.9377C23.7063 10.0377 23.2 9.86895 22.1312 9.8127C21.0625 9.75645 18.3625 9.7002 16 9.7002C13.6375 9.7002 10.9375 9.75645 9.86876 9.8127C8.80001 9.86895 8.23747 10.0377 7.78747 10.9377C7.28122 11.8377 7.00003 13.3564 7.00003 16.0002C7.00003 18.6439 7.28122 20.1627 7.78747 21.0627C8.29372 21.9627 8.80001 22.1314 9.86876 22.1877C10.9375 22.2439 13.6375 22.3002 16 22.3002C18.3625 22.3002 21.0625 22.2439 22.1312 22.1877C23.2 22.1314 23.7625 21.9627 24.2125 21.0627C24.7188 20.1627 25 18.6439 25 16.0002C24.9438 13.3564 24.7188 11.8377 24.2125 10.9377ZM14.2 19.3189V12.7377L19.3187 16.0564L14.2 19.3189Z"
      fill="currentColor"
    />
  </svg>
)
